module.exports = __webpack_public_path__ + "static/media/IMG_7565.80c0290e.jpg";